import axios from "axios";
import { StorageManager } from "./StorageManager";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});
/*
function navigateTo(path, rep) {
  const navigate = useNavigate();
  navigate(path, { replace: rep });
}
*/
// Set the AUTH token for any request
client.interceptors.request.use((config) => {
  const userManager = new StorageManager("authUser");
  const auth_user = userManager.get();
  const newConfig = config;

  try {
    if (auth_user !== null) {
      newConfig.headers.Authorization = auth_user.user_token;
    }
  } catch (error) {
    console.log("authUser", error);
  }
  return newConfig;
});

/* eslint-disable */
client.interceptors.response.use(
  (response) => {
    switch (response.status) {
      case 200:
        return response.data;
      case 401:
        userManager.remove();
        navigateTo("/", true);
      case 403:
        userManager.remove();
        navigateTo("/", true);
      case 404:
        navigateTo("/notFound", false);
      case 500:
        return response.data;
      case 502:
        navigateTo("/notFound", false);
        return JSON.parse("[{}]");
      default:
        return response.data;
    }
  },
  (error) => {    
    if (error.response.status === 401) {
      const userManager = new StorageManager("auth_user");
      const auth_user = userManager.get();
      
      if (auth_user) userManager.remove();      
      document.location.href = "/login";
    }
    
    return error.response.data;
    //if (error.response.status === 400) return error.response.data;
  }
);

export default client;
